import { Loading } from '@winnin/winnin_ui.components.loading'

import { AuthContextProvider } from 'contexts/AuthContext'
import Error500 from 'pages/ErrorPage/errors/e500'

import type { IAuthGateViewProps } from './auth-gate.types'

/**
 * Pure presentation: renders the state computed by `useAuthGate` (called by the bridge). All auth
 * interpretation, data fetching and side effects live in the model — the view only switches on
 * `state.status`.
 */
export function AuthGateView({ state, children }: IAuthGateViewProps) {
  if (state.status === 'loading') return <Loading />
  if (state.status === 'error') return <Error500 />

  return (
    <AuthContextProvider keycloak={state.keycloak} me={state.me}>
      {children}
    </AuthContextProvider>
  )
}
